import React, { useState, useEffect } from "react";
import { Button, RadioButton } from '../../../common/commonIndex';

const StepSex = ({ handleNextEvent, formData, getPersonalInfo, updatePersonalInfo }) => {

    const gender = ['Female', 'Male'];

    const [selectedValue, setSelectedValue] = useState(formData?.sex || "");
    const [isValid, setIsValid] = useState(false);
    useEffect(() => {
        if (formData?.sex) {
            setSelectedValue(formData?.sex);
            setIsValid(true);
        }else{
            setSelectedValue('');
            setIsValid(false);
        }
        if (formData.email && formData.firstName && formData.lastName && formData.sex && formData.day && formData.month && formData.year) {
            getPersonalInfo();
        }
    });
    /* Callback function to handle radio button change */
    const handleRadioChange = (value) => {
        setSelectedValue(value);
        setIsValid(true);
        formData.sex = value;
    };

    /* Submit */
    const handleSubmit = (e) => {
        e.preventDefault();
        if (formData.email && formData.firstName && formData.lastName && formData.sex && formData.day && formData.month && formData.year) {
            updatePersonalInfo(formData)
        } else {
            handleNextEvent(6);
        }
    };

    return (
        <div className="email-form-container">
            <h2 className="title">What is your sex?</h2>
            <p className="sub-title">Your biological sex is important for your health care providers to deliver appropriate care.</p>

            <form onSubmit={handleSubmit}>
                <div className="list radio-button radiobuton-gender gender mb-5">
                    {gender?.map((item, index) => {
                        const isSelected = selectedValue === item;
                        const className = isSelected ? "list-item selected" : "list-item";

                        return (
                            <div className={className} key={index}>
                                <RadioButton
                                    radioButton="gender"
                                    name={item}
                                    id={index}
                                    onRadioChange={handleRadioChange}
                                    formData={formData}
                                    value={selectedValue}
                                    setValue={setSelectedValue}
                                />
                            </div>
                        );
                    })}
                </div>

                <Button
                    btnClass={'btn-primary'}
                    btnType={'submit'}
                    btnName={'Next'}
                    onClick={handleSubmit}
                    isDisabled={isValid}
                />
            </form>
        </div>
    )
}

export default StepSex;